const DEV_ENVS = ['dev', 'sit'] as const;
const CUSTOM_ENV = import.meta.env.VITE_CUSTOM_ENV;
const FEATURE_FLAGS_ENDPOINT_ERROR =
  'VITE_FEATURE_FLAGS_ENDPOINT is required for remote feature flags';

type FeatureFlagsConfig =
  | { mode: 'local' }
  | { mode: 'remote'; endpoint: string };

const getRemoteFeatureFlagsEndpoint = (): string => {
  const endpoint = import.meta.env.VITE_FEATURE_FLAGS_ENDPOINT;
  if (!endpoint) {
    throw new Error(FEATURE_FLAGS_ENDPOINT_ERROR);
  }

  return endpoint;
};

const isLocalFeatureFlagsEnvironment = (DEV_ENVS as readonly string[]).includes(
  CUSTOM_ENV,
);

export const FEATURE_FLAGS_CONFIG: FeatureFlagsConfig =
  isLocalFeatureFlagsEnvironment
    ? { mode: 'local' }
    : { mode: 'remote', endpoint: getRemoteFeatureFlagsEndpoint() };

export const IS_PROD = CUSTOM_ENV === 'prod';

export const IS_DEV_ENV = CUSTOM_ENV === 'dev';

export const RRWEB_ENABLED = import.meta.env.VITE_ENABLE_RRWEB === 'true';
